<template>
  <div class="sms-jump-ad">
    <div class="pact">
      <p class="pact-title">高精度流动站租赁须知</p>
      <p class="sub-title">一、设备租赁</p>
      <p class="pact-content">设备名称：高精度流动站</p>
      <p class="pact-content">一次性买断学时金，一经支付，不予退款。买断学时平台将一次性分配至对应设备，具体时长以后台显示为准。</p>
      <p class="sub-title">二、支付流程条款</p>
      <p class="pact-content">1. 平台将学员付费课时所产生的奖励支付至付费学时订单产生时所登录的超级教练APP账号内，教练可依照平台规则自行提现，并自行承担对所得奖励金申报和缴纳个税的义务。</p>
      <p class="pact-content">2. 教练如需向平台额外支付赔偿费用的，教练需及时打款至平台指定的银行账户，汇款时需备注汇款人及路考仪的设备编号。</p>
      <p class="pact-content">平台收款账户：车轮互联科技（上海）股份有限公司</p>
      <p class="pact-content">账号： 310066580013000721922</p>
      <p class="pact-content">开户行：交通银行上海浦东分行</p>
      <p class="sub-title">三、赔偿条款</p>
      <p class="pact-content">如教练在使用时造成所租设备损坏，则按以下价格赔偿：</p>
      <p class="pact-content">流动站天线套件</p>
      <p class="pact-content">1) 蘑菇头天线：800元/个；</p>
      <p class="pact-content">2) 磁性天线吸盘底座：50元/个；</p>
      <p class="pact-content">3) 连接杆：50元/个；</p>
      <p class="pact-content">4) RTK 馈线3-4米（注塑）：50元/个；</p>
      <p class="pact-content">流动站主机盒套</p>
      <p class="pact-content">1) 高精度主机盒（串口版）-RTK板卡：2000元；</p>
      <p class="pact-content">2) 高精度主机盒（串口版）-PCB底板：1300元；</p>
      <p class="pact-content">3) 串口数据连接线4M：50元；</p>
      <p class="pact-content">4) 稳压电源：300元；</p>
      <p class="pact-content">其他损坏赔偿：按市场价赔偿。</p>
      <p class="sub-title">四、注意事项</p>
      <p class="pact-content">1. 教练需确保其在“超级教练路考仪”设备激活提交的姓名、联系方式真实有效，否则设备不能使用由教练自行承担后果</p>
      <p class="pact-content">2. 安装完成后，请使用微信/支付宝“扫一扫”设备上的激活码，提交设备激活申请，激活后即可正常使用该设备；</p>
      <p class="pact-content">3. 双方同意设备发货、返修、退还等过程中产生的运费均由寄件方承担；</p>
      <p class="pact-content">4. 设备的安装指导、调试等其他事项，可联系当地服务商，期间产生的拆装费由当地服务商收取，与甲方无关。若无服务商的，可直接联系超级教练团队，联系方式可以通过超级教练app查看;</p>
      <p class="pact-content">5. 教练在租用期间不得转租；</p>
      <p class="pact-content">6. 教练不能擅自拆改设备，必须妥善正确使用，确保设备完好无损，否则造成的一切损失由教练承担；</p>
      <p class="pact-content">7. 教练不得自行或允许第三方对设备进行拆卸、改装、替换、增加或减少部件等一切损害甲方权益的行为，否则甲方有权解除本协议，教练应当支付10万元人民币作为违约金，违约金不足以弥补甲方损失的，还应当补足;</p>
      <p class="pact-content">8. 教练不得自行或允许第三方获取、披露、使用设备内包含的用户信息以及本协议项下的甲方商业信息，并不得私自更换设备中包含的信息，如支付信息、所有者信息、传输信息等。否则甲方有权解除本协议，教练应当支付10万元人民币作为违约金，违约金不足以弥补甲方损失的，还应当补足;</p>
      <p class="pact-content">9. 禁止私自拆卸、更换设备的零部件、附件等物。如有违规，将按被拆物件的新件价格的10倍处以罚款。情节严重的，甲方有权要求教练退还设备，教练拒不退还设备或支付赔偿的，甲方有权通过法律途径向教练追偿，同时甲方将有权不再对教练提供任何租赁与售卖服务。</p>      
    </div>
  </div>
</template>

<script>
const date = new Date()
export default {
  data () {
    return {
      order: {},
      year: date.getFullYear(),
      month: date.getMonth(),
      day: date.getDate(),
      price: 0
    }
  },
  created: function () {
  },
  methods: {
  },
  mounted () {
  }
}
</script>

<style scoped lang="scss">
.pact {
  background: #fff;
  font-size: .24rem;
  line-height: 1.6;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 0 .3rem;
  z-index: 999;
  padding-bottom: 20px;
  .pact-title {
    text-align: center;
    font-size: .34rem;
    font-weight: 600;
    line-height: 1rem;
  }
  .sub-title {
    margin-top: 10px;
    font-size: .28rem;
    font-weight: 600;
  }
  .pact-content {
    text-indent: 1em;
    span {
      display: inline-block;
      border-bottom: 1px solid #000;
      min-width: 50px;
      text-align: center;
      text-indent: 0;
    }
  }
  .pact-hint {
    text-align: center;
    margin: 20px auto;
  }
  .footer {
    display: -webkit-flex;
    display: flex;
    span:first-child {
      flex: 3;
    }
    span:last-child {
      flex: 2;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/pactList/leasePactNew.vue